export default __webpack_public_path__ + "img/banner-2.fc724df82cb0f81f26cc3cd8a9a936cc.jpg";